<div class="form-field"
     [class.error]="(control.touched && control.invalid) || invalid"
>
  <div *ngIf="label" [ngClass]="{disabled: control.disabled, datepicker: datepicker}" class="label default">
    <div>
          {{label}} 
          <span class="optional" *ngIf="optional">(optional)</span>
          <div class="tooltip" *ngIf="tooltipText">
               <img class="ml-1" [src]="'assets/icons/' + tooltipIconName + '.svg'"/> 
               <span class="tooltiptext" [style.width]="tooltipTextWidth ? tooltipTextWidth + 'px' : 'max-width'">{{tooltipText}}</span>
          </div>
     </div> 
    <div class="symbols-left-counter" *ngIf="symbolsLeftCounter">{{value?.length || 0}}/{{maxLength}}</div>
  </div>

  <div class="input-container"
       [ngClass]="{'focused-error-border': showFocusedErrorBorder,
                   'focused': isFocused,
                   'with-prefix': prefix,
                   'with-suffix': icon || (control.touched && control.invalid && showErrors) || (control.errors && control.errors['password']),
                   'datepicker': datepicker,
                   'read-only': readOnly
                    }"
        [style]="{'margin-right': isNdcQty ? '-10px' : '0px'}"
  >
    <div *ngIf="prefix" class="prefix">{{prefix}}</div>

    <input
      #appInput
      [(ngModel)]="value"
      (ngModelChange)="valueChanged.emit($event)"
      (blur)="onBlur()"
      (focus)="onFocus()"
      [type]="type === 'password' ? (hidePassword ? 'password' : 'text') : type"
      [placeholder]="placeholder || ''"
      [id]="formControlName || id"
      [name]="formControlName"
      [tabindex]="tabInd"
      (keydown.enter)="keyupEnter.emit($event)"
      (keydown.tab)="keydownTab.emit($event)"
      (keyup.backspace)="keyupBackspace.emit($event)"
      [autofocus]="autofocus"
      [disabled]="disable"
      [maxLength]="maxLength"
      autocomplete="new-password"
      [mask]="type === 'phone' ? phoneInputMask : inputMask"
      (keydown)="onKeyDown($event)"
      [style]="{'text-align': textAlign}"
      [min]="min"
      [ngClass]="[customClasses]"
      [autocomplete]="autocomplete"
    />

    <ng-content></ng-content>
    
    <img *ngIf="control.touched && control.invalid && !icon && !hideErrorIcon && showErrors && !control.errors['password']"
         class="suffix-icon error"
         src="assets/icons/icon-field-error.svg"
         alt="error-icon"
    />

    <img *ngIf="type === 'password' && (!control.invalid || control.errors['password'] || !control.touched)"
         (click)="toggleHidePassword()" [hidden]="hidePassword"
         class="suffix-icon password" src="assets/icons/icon-field-hide-password.svg" alt="password-icon"/>
    <img *ngIf="type === 'password' && (!control.invalid || control.errors['password'] || !control.touched)"
         (click)="toggleHidePassword()" [hidden]="!hidePassword"
         class="suffix-icon password" src="assets/icons/icon-field-show-password.svg" alt="password-icon"/>

    <img class="suffix-icon" [ngClass]="iconClasses" *ngIf="icon" [src]="'assets/icons/icon-' + icon + '.svg'" [alt]="icon" 
     (click)="onIconClick.emit()"/>
  </div>

  <div *ngIf="(control.touched && control.invalid && showErrors) || (invalid && errorMessage)"
       class="error-message"
       [ngClass]="{'weak-password': control.errors?.password === 'weak',
       'mediate-password': control.errors?.password === 'mediate',
       'strong-password': control.errors?.password === 'strong',
       'error-nowrap': isErrorNoWrap}"
  >
    {{errorMessage ? errorMessage : getErrorMessage()}}
  </div>
</div>
